export default "__VITE_ASSET__029c00dd__"